/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingCommitmentEvent extends models.BillingCommitmentBase {
    getFixupPrototypeFunction() { return BillingCommitmentEvent.fixupPrototype; }

    static newInstance(model: Partial<BillingCommitmentEvent>): BillingCommitmentEvent {
        let obj = Object.assign(new BillingCommitmentEvent(), model);
        BillingCommitmentEvent.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingCommitmentEvent>): BillingCommitmentEvent {
        if (!model) return null;
        return BillingCommitmentEvent.newInstance(<BillingCommitmentEvent> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingCommitmentEvent) {
        if (!obj) return;

        models.BillingCommitmentEvent.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingCommitmentEvent): boolean {
        if (models.BillingCommitmentBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingCommitmentEvent.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.charges === undefined) {
            this.charges = 0;
        }
        if (typeof this.transaction_date === "string") {
            this.transaction_date = new Date(<string><any>this.transaction_date);
        }
    }

    /**
     * Billing Account Name
     */
    billing_account_name: string;

    /**
     * Billing Profile Name
     */
    billing_profile_name: string;

    /**
     * Billing Commitment Description
     */
    description: string;

    /**
     * Billing Charges
     */
    charges: number;

    /**
     * Event Transaction Date
     */
    transaction_date: Date;

}
